import { propOr, pathOr } from "ramda";

export const getState = state => state;

export const getBusiness = propOr(null, "business");

export const getThemeColor = pathOr(null, ["business", "theme_color"]);

export const getTextColor = pathOr(null, ["business", "text_color"]);

export const getLauncherIcon = pathOr(null, ["business", "launcher_icon"]);
